import { Box } from '@mui/material';
import LendingTermsDesktop from './LendingTermsComponent';

export default function LendingTerms() {
  return (
    <Box mt={['2.75rem', '2.75rem', '5.5625rem']}>
      <LendingTermsDesktop />
    </Box>
  );
}
